"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _format = require("../utils/format");

var _PlanModule = _interopRequireDefault(require("./Plan.module.scss"));

var _ = _interopRequireDefault(require("@wisetack/assets/img/3.svg"));

var _2 = _interopRequireDefault(require("@wisetack/assets/img/6.svg"));

var _3 = _interopRequireDefault(require("@wisetack/assets/img/12.svg"));

var _4 = _interopRequireDefault(require("@wisetack/assets/img/24.svg"));

var _5 = _interopRequireDefault(require("@wisetack/assets/img/36.svg"));

var _6 = _interopRequireDefault(require("@wisetack/assets/img/60.svg"));

var _birds = _interopRequireDefault(require("@wisetack/assets/img/3-birds.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Plan(_ref) {
  var item = _ref.item,
      _onClick = _ref.onClick;

  var PlanImage = function PlanImage() {
    var image = null;

    switch (item.months) {
      case 3:
        image = _["default"];
        break;

      case 6:
        image = _2["default"];
        break;

      case 12:
        image = _3["default"];
        break;

      case 24:
        image = _4["default"];
        break;

      case 36:
        image = _5["default"];
        break;

      case 60:
        image = _6["default"];
        break;

      default:
        image = _birds["default"];
    }

    return /*#__PURE__*/_react["default"].createElement("img", {
      className: _PlanModule["default"].logo,
      src: image,
      alt: "plan-logo"
    });
  };

  var style = {};

  if (item.status === "SELECTED") {
    style.borderColor = "#07c0ca";
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _PlanModule["default"].plan,
    style: style,
    onClick: function onClick() {
      return _onClick && _onClick();
    }
  }, /*#__PURE__*/_react["default"].createElement(PlanImage, null), /*#__PURE__*/_react["default"].createElement("div", {
    className: _PlanModule["default"].months
  }, item.months, " MONTH PLAN"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _PlanModule["default"].amount
  }, (0, _format.formatAmount)(item.amount), "/mo"), item.apr === 0 && !item.skipFree && /*#__PURE__*/_react["default"].createElement("div", {
    className: _PlanModule["default"].free
  }, "INTEREST FREE"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _PlanModule["default"].total
  }, (0, _format.formatAmount)(item.interest), " TOTAL INTEREST (", (0, _format.formatAPR)(item.apr), ")"));
}

Plan.propTypes = {
  item: _propTypes["default"].object.isRequired,
  onClick: _propTypes["default"].func
};
var _default = Plan;
exports["default"] = _default;